const NoOrders = () => (
  <div className="c7-account__dashboard__message">
    <p>You have not yet placed an order.</p>
  </div>
);

export default NoOrders;
